// src/Section/Home/Terravia.jsx

import React from "react";
import Banner from "../../Section/Home/Banner/banner";
import Desktop from "../../Media/Header/Desktop/Desktop_Terravia.webp";
import Mobile from "../../Media/Header/Mobile/Mobile_Terravia.webp";
import About from "../../Section/Detail/about/about.jsx";
import Promo from "../../Section/Home/Promo/promo";
import Lokasi from "../../Section/Home/Lokasi/lokasi";
import Terraviadata from "./Terravia.json";
import promoData from "./promo.json";
import logo from "../../Media/RumahLogo/Terarialogo.webp";
import hardsell from "../../Media/Promo/Hardesell_Terravia.webp";
import Produk from "../Terravia/Terravia1/Terravia1.jsx";
import Fasilitas from "../../Section/Home/Fasilitas/fasilitas.jsx";
import Fasilitasdata from "./fasilitas.json"; // Ensure this path is correct
import Fasilitasimages from "../../Media/Fasilitas BSD/Terravia/Terraviaf.js"; // Ensure this path is correct
import Surrounding from "../../Section/Home/surrounding/Surrounding.jsx";

const Terravia = () => {
  return (
    <div>
      <Banner Desktop={Desktop} Mobile={Mobile} />
      <About
        logo={logo}
        judul={Terraviadata.judul}
        Deskripsi={Terraviadata.deskripsi}
      />
      <Promo
        image={hardsell}
        title={promoData.title}
        points={promoData.points}
        whatsapp={promoData.whatsapp}
      />
      <Produk />
      <Fasilitas
        title={Fasilitasdata.title}
        description={Fasilitasdata.description}
        facilities={Fasilitasdata.facilities}
        images={Fasilitasimages} // Pass images as a prop
      />
      <Surrounding />

      <Lokasi />
    </div>
  );
};

export default Terravia;
